export default __webpack_public_path__ + "static/media/Deloitte.17464623.svg";